// extracted by mini-css-extract-plugin
export default {"contain":"Video_contain__pqODK"};